import React, { PropsWithChildren } from 'react'
import { addDDError } from 'services/AnalyticsLite/Datadog/events'

interface Props {
	fallback?: JSX.Element
	fallbackFn?: () => JSX.Element
}

interface State {
	hasError: boolean
	error: Error | null
}

export class SuspenseErrorBoundary extends React.Component<PropsWithChildren<Props>, State> {
	constructor(props: Props) {
		super(props)
		this.state = { hasError: false, error: null }
	}

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
		console.error(error, errorInfo)
		addDDError(error, errorInfo)
	}

	static getDerivedStateFromError(error: Error) {
		return {
			hasError: true,
			error
		}
	}

	render() {
		if (this.state.hasError) {
			if (this.props.fallbackFn) return this.props.fallbackFn()
			if (this.props.fallback) return this.props.fallback
			return null
		}
		return this.props.children
	}
}
